import { render } from "./ProductActivation.vue?vue&type=template&id=42656740&scoped=true"
import script from "./ProductActivation.vue?vue&type=script&lang=js"
export * from "./ProductActivation.vue?vue&type=script&lang=js"

import "./ProductActivation.vue?vue&type=style&index=0&id=42656740&lang=less&scoped=true"

import exportComponent from "D:\\cwzl\\four-cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42656740"]])

export default __exports__